<template>
  <div>
    <Dialog
      :key="formKey"
      :visible.sync="supportCaseDialog1"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Support Case"
      :modal="true"
      class="p-fluid"
    >
      <template #header>
        <h5>Support Case</h5>
      </template>
      <div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="status">Status</label>
            <Dropdown
              id="status"
              v-model="supportCase.status"
              :options="statuses"
              optionLabel="name"
              placeholder="Select Status"
              :showClear="true"
              :class="{ 'p-invalid': submitted && !supportCase.status }"
              :disabled="true"
            />
            <small class="p-invalid" v-if="submitted && !supportCase.status"
              >Status is required.</small
            >
          </div>
          <div class="p-field p-col">
            <label for="type">Type</label>
            <Dropdown
              id="type"
              v-model="supportCase.type"
              :options="types"
              optionLabel="name"
              placeholder="Select Type"
              :showClear="true"
              :class="{ 'p-invalid': submitted && !supportCase.type }"
            />
            <small class="p-invalid" v-if="submitted && !supportCase.type"
              >Type is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="description">Description</label>
            <InputText
              id="description"
              v-model.trim="supportCase.description"
              :class="{ 'p-invalid': submitted && !supportCase.description }"
            />
            <small
              class="p-invalid"
              v-if="submitted && !supportCase.description"
              >The Description is required</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="details">Details</label>
            <Textarea
              id="details"
              v-model.trim="supportCase.details"
              :class="{ 'p-invalid': submitted && !supportCase.details }"
              rows="4"
              cols="30"
              placeholder="Enter details of what you clicked just before you got an error/unexpected results and give as much details as possible"
            />
            <small class="p-invalid" v-if="submitted && !supportCase.details"
              >The Details is required</small
            >
          </div>
        </div>
        <!-- <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="resolution">Resolution</label>
            <InputText
            id="resolution"
            v-model.trim="supportCase.resolution"
            :class="{ 'p-invalid': submitted && !(supportCase.resolution) }"             
            />
            <small class="p-invalid" v-if="submitted && !(supportCase.resolution)">The Resolution is required</small>
          </div>
        </div> -->
        <!-- <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="lastEP">Last EP</label>
            <InputText
            id="lastEP"
            v-model.trim="supportCase.lastEP"
            :disabled="true"
            />
          </div>
        </div> -->
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="epError">EP ERROR</label>
            <InputText
              id="epError"
              v-model.trim="supportCase.epError"
              :disabled="true"
            />
          </div>
        </div>
        <!-- <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="epPayload">EP Payload</label>
            <InputText
            id="epPayload"
            v-model.trim="supportCase.epPayload"
            :disabled="true"
            />
          </div>
        </div> -->

        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="errorCode">Error Code</label>
            <InputText
              id="errorCode"
              required="true"
              style="text-transform: uppercase;"
              v-model="supportCase.errorCode"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col">
            <label for="caseNo">EP Date and Time</label>
            <InputText
              id="datetime"
              required="true"
              v-model="supportCase.datetime"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col">
            <label for="active">Active?</label>
            <SelectButton
              v-model="supportCase.active"
              :options="options"
              optionLabel="label"
              optionValue="value"
              :class="{ 'p-invalid': submitted && !supportCase.active }"
              :disabled="true"
            />
            <small class="p-invalid" v-if="submitted && !supportCase.active"
              >Active is required.</small
            >
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="screenshot">Screenshot</label>
            <div class="p-inputgroup">
              <InputText :value="attachment.fileName" :disabled="true" />
              <Button
                icon="pi pi-download"
                @click="downloadScreeshot"
                class="p-button-primary"
              />
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            class="p-button-danger"
            style="width: 100px;"
            @click="hideDialog"
          />
          <ProgressSpinner
            v-if="sendingRequest"
            style="width:25px; height:25px; width: 100px;"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"
          />
          <Button
            v-else
            label="Save"
            icon="pi pi-check"
            class="p-button-success"
            style="width: 100px;"
            @click="saveSupportcase"
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import SupportCaseService from "@/service/SupportCaseService";
import AttachmentService from "@/service/AttachmentService";

import { saveSupportCase } from "../universalComponents/sendRequest";

import { mapGetters, mapActions } from "vuex";

export default {
  props: ["supportCaseDialog", "supportCaseToEdit", "attachment"],
  data: () => ({
    supportCaseService: new SupportCaseService(),
    attachmentService: new AttachmentService(),
    formKey: 0,
    submitted: false,
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ],
    sendingRequest: false,
    supportCase: {
      type: null,
      description: null,
      details: null,
      resolution: null,
      lastEP: null,
      epError: null,
      epPayload: null,
      errorCode: null,
      datetime: null,
      status: {
        id: 0,
        name: "NEW"
      },
      active: true,
      screenshot: null,
      loggedInUser: null
    },
    types: [
      {
        id: 0,
        name: "Error Message",
        code: "ERROR_MSG"
      },
      {
        id: 1,
        name: "Screen Issue",
        code: "SCREEN_ISSUE"
      },
      {
        id: 2,
        name: "Permission Issue",
        code: "PERMISSION_ISSUE"
      },
      {
        id: 3,
        name: "Unexpected Behaviour",
        code: "UNEXPECTED_BEHAVIOUR"
      },
      {
        id: 4,
        name: "Other",
        code: "OTHER"
      }
    ],
    statuses: [
      {
        id: 0,
        name: "NEW"
      },
      {
        id: 1,
        name: "VERIFIED"
      },
      {
        id: 2,
        name: "ASSIGNED"
      },
      {
        id: 3,
        name: "ONHOLD"
      },
      {
        id: 4,
        name: "RESOLVED"
      },
      {
        id: 5,
        name: "DONE"
      }
    ]
  }),
  computed: {
    supportCaseDialog1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.supportCaseDialog ? true : false;
      }
    },
    ...mapGetters([
      "getLastErrorEP",
      "getEpDatetime",
      "getEpPayload",
      "getEpError",
      "getErrorCode"
    ])
  },
  watch: {
    supportCaseDialog1(val) {
      if (val) {
        // this.setupCustomerToEdit()
      }
      this.supportCase.epError = this.getEpError;
      this.supportCase.errorCode = this.getErrorCode;
      this.supportCase.datetime = this.getEpDatetime;
      this.supportCase.lastEP = this.getLastErrorEP;
      this.supportCase.epPayload = this.getEpPayload;
      this.formKey++;
    }
  },
  methods: {
    saveSupportcase() {
      this.sendingRequest = true;
      this.submitted = true;
      this.supportCase.loggedInUser = this.$store.getters[
        "auth/getMyProfile"
      ].id;
      try {
        saveSupportCase(this, "SupportCaseForm.vue");
      } catch (e) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error while adding SupportCase",
          life: 5000
        });
      }
    },
    showMsg() {
      this.$toast.add({
        severity: "success",
        detail: "The issue/error has been submitted successfully",
        life: 5000
      });
    },
    hideDialog() {
      this.$emit("close");
    },
    async downloadScreeshot() {
      this.attachmentService.fileDownloader(this.attachment.fileName);
    }
  }
};
</script>

<style></style>
